import React, { SetStateAction, useCallback, useEffect, useState } from "react";
import {
  GridContainer,
} from "./ExerciseGridView.css";
import ReactPlayer from "react-player";
import "../../../styles.css";

interface GridVideoProps {
  switchPlayerToSpotlight: (
    newSpotlight: number,
    videoRef: React.RefObject<ReactPlayer>,
    currentTime: number
  ) => void;
  currentTime: number;
  playPauseHandler: () => void;
  playing: boolean;
  loop: boolean;
  ref1: React.RefObject<ReactPlayer>;
  ref2: React.RefObject<ReactPlayer>;
  ref3: React.RefObject<ReactPlayer>;
  ref4: React.RefObject<ReactPlayer>;
  links: {
    url1: string;
    url2: string;
    url3: string;
    url4: string;
  };
  handleProgress: (event: any) => void;
  updateRefsWithCurrentTime: () => void;
}

function ExerciseGridView({
  switchPlayerToSpotlight,
  playPauseHandler,
  currentTime,
  playing,
  loop,
  ref1,
  ref2,
  ref3,
  ref4,
  links,
  handleProgress,
  updateRefsWithCurrentTime
}: GridVideoProps) {

  const handleDoubleClick = (
    newSpotlight: number,
    videoRef: React.RefObject<ReactPlayer>,
  ) => {
    switchPlayerToSpotlight(newSpotlight, videoRef, videoRef.current?.getCurrentTime());
  };

  const onClick = (
    {target}: any,
    newSpotlight: number,
    videoRef: React.RefObject<ReactPlayer>,
    ) => {
    if (isNaN(target.cn)) {
      target.cn = 1 
    } else {
      target.cn++
    }
    setTimeout(() => {
      if (target.cn == 1) {
        playPauseHandler();
        target.cn = 0
      }
      if (target.cn > 1) {
        handleDoubleClick(newSpotlight, videoRef);
        target.cn = 0
      }
    }, 500)  
  }

  return (
      <GridContainer>
        <ReactPlayer
          ref={ref1}
          className={"player"}
          onClick={(event: any) => onClick(event, 1, ref1)}
          url={links.url1}
          playing={playing}
          loop={loop}
          muted={true}
          controls={false}
          width={"600px"}
          onProgress={handleProgress}
          progressInterval={100}
          onReady={updateRefsWithCurrentTime}
        />
        <ReactPlayer
          ref={ref2}
          className="player"
          onClick={(event: any) => onClick(event, 2, ref2)}
          url={links.url2}
          playing={playing}
          loop={loop}
          muted={true}
          controls={false}
          width={"600px"}
        />
        <ReactPlayer
          ref={ref3}
          className="player bottom-row"
          onClick={(event: any) => onClick(event, 3, ref3)}
          url={links.url3}
          playing={playing}
          loop={loop}
          muted={true}
          controls={false}
          width={"600px"}
        />
        <ReactPlayer
          ref={ref4}
          className="player"
          onClick={(event: any) => onClick(event, 4, ref4)}
          url={links.url4}
          playing={playing}
          loop={loop}
          muted={true}
          controls={false}
          width={"600px"}
        />
      </GridContainer>
  );
}

export default ExerciseGridView;
